import {Component, Input, OnInit} from '@angular/core';
import {ExcRestService} from 'exc-rest-v2';
import {ExgModalService} from 'exc-controls-v2';
import {ExcSecurityService} from 'exc-security-v2';
import {EnumerationService} from '../../services/enumeration.service';
import {ExcTranslation} from 'exc-core-v2';
import {ApplicationService} from '../../services/application.service';
import {ExgMapPlacesServices} from 'exc-map-v2';

@Component({
  selector: 'app-modal-oe',
  templateUrl: './modal-oe.component.html',
  styles: [
  ]
})
export class ModalOeComponent extends ExcTranslation implements OnInit {
  @Input() data: any = {
    new: true,
    showAssignButton: false,
    oeIDparent: '00000000-0000-0000-0000-000000000000'
  };
  OEDetails = {
    oe_enmName_OETyp: 'OETyp',
    oe_enmIdent_OETyp: this.enumService.getEnumerationDefaultValue('OETyp'),
    oe_enmIdent_AnredeTyp: this.enumService.getEnumerationDefaultValue('AnredeTyp'),
    oeNPraefix: '',
    oeName: '',
    oeEName: '',
    oe_CrmRolle: this.enumService.getEnumerationDefaultValue('CrmRolleOrganisation'),
    oeID: undefined
  };
  UiOEModel = {
    // oeID: '',
    oe_enmName_OETyp: 'OETyp',
    oe_enmIdent_OETyp: this.enumService.getEnumerationDefaultValue('OETyp'),
    oe_enmIdent_AnredeTyp: this.enumService.getEnumerationDefaultValue('AnredeTyp'),
    oeNPraefix: '',
    oeName: '',
    oeEName: '',
    oe_CrmRolle: this.enumService.getEnumerationDefaultValue('CrmRolleOrganisation')
  } as any;

  ContactsList = {
    oeContact: {} as any,
    oeContactClone: {} as any,
    data: [] as any[],
  };

  AddressesList = {
    oeAddress: {} as any,
    oeAddressClone: {} as any,
    data: [] as any[],
  };

  locName = '';
  placesList = [] as any[];
  selectedLocation: any;
  locActive = false;
  locNew = false;
  MapZoom = 13;

  showManuel = true;
  changedManuel = false;
  predefinedAddressType = false;

  visibilityController = {
    showAddressEditor: false,
    showContactEditor: false,
    showOEEditor: false,
    changeContactEditor: (index: number = -1): void => {
      if (!this.excSecurity.isFeatured('CRMEDIT')) {
        return;
      }
      if (!this.visibilityController.showOEEditor) {
        if (!this.visibilityController.showContactEditor) {
          this.ContactsList.oeContact =
            this.ContactsList.oeContactClone = {};
        }
        if (index === -1) {
          this.visibilityController.showContactEditor = !this.visibilityController.showContactEditor;
        } else {
          this.visibilityController.showContactEditor = !this.visibilityController.showContactEditor;
          this.ContactsList.oeContact = this.ContactsList.data[index];
          this.ContactsList.oeContactClone = this.appService.helperObj.clone(this.ContactsList.oeContact);
        }
      }
    },
    changeAddressEditor: (index: number = -1): void => {
      if (!this.excSecurity.isFeatured('CRMEDIT')) {
        return;
      }
      if (!this.visibilityController.showOEEditor) {
        if (!this.visibilityController.showAddressEditor) {
          this.showManuel = true;
          this.AddressesList.oeAddress =
            this.AddressesList.oeAddressClone = {};
        }
        if (index === -1) {
          this.visibilityController.showAddressEditor = !this.visibilityController.showAddressEditor;
          this.showManuel = false;
        } else {

          this.visibilityController.showAddressEditor = !this.visibilityController.showAddressEditor;
          this.AddressesList.oeAddress = this.AddressesList.data[index];
          this.AddressesList.oeAddressClone = this.appService.helperObj.clone(this.AddressesList.oeAddress);

          if (this.AddressesList.oeAddressClone.adrLat && this.AddressesList.oeAddressClone.adrLng) {
            this.locActive = true;
            this.showManuel = false;
          } else {
            this.locActive = false;
            this.showManuel = true;
          }
        }
      }
    }
  };
  disabledController = {
    oeSavingDisabled: true,
    checkIfOESavable: (): void => {
      this.disabledController.oeSavingDisabled = JSON.stringify(this.UiOEModel) === JSON.stringify(this.OEDetails);
    }
  };

  isLoading = false;
  crmRolleIsPredefined = false;
  enmIdentOETypIsPredefined = false;
  showHintText = false;
  isOeNew = false;

  OETypEnumList = this.enumService.getEnumerationList('OETyp');
  constructor(
    private appSvc: ApplicationService,
    public excRest: ExcRestService,
    public modal: ExgModalService,
    public excSecurity: ExcSecurityService,
    public enumService: EnumerationService,
    public appService: ApplicationService,
    public placesService: ExgMapPlacesServices,
  ) {
    super();
  }

  ngOnInit(): void {
    if (!this.data.new && this.data.OEDetails) {
      this.OEDetails = this.data.OEDetails;
      this.UiOEModel = this.appService.helperObj.clone(this.OEDetails);
      this.AddressesList.data = this.data.Addresses;
      this.ContactsList.data = this.data.Contacts;
    } else {
      /*isNew -> set standard OE Details*/
      if (this.data.isCompany) {
        this.OEDetails.oe_enmIdent_OETyp = 3;
        this.OEDetails.oe_enmIdent_AnredeTyp = null;
      }else {
        this.OEDetails.oe_enmIdent_OETyp = 2;
      }
      this.toggleOEEditor();
    }
    if (this.data.predefinedCrmRolle) {
      this.crmRolleIsPredefined = true;
      this.OEDetails.oe_CrmRolle = this.data.predefinedCrmRolle;
    }
    if (this.data.predefinedEnmIdentOETyp) {
      this.enmIdentOETypIsPredefined = true;
      this.OEDetails.oe_enmIdent_OETyp = this.data.predefinedEnmIdentOETyp;
    }
    if (this.data.isCompany && !this.data.predefinedEnmIdentOETyp) {
      this.OETypEnumList = this.OETypEnumList.filter(item => item.enmIdent !== 2);
    }
    this.isOeNew = this.data.new;
  }
  /*Saving & Cancel Saving*/
  saveOEEditor(): void {
    const uiName = this.enumService.getEnumerationText(
      this.UiOEModel.oe_enmName_OETyp,
      this.UiOEModel.oe_enmIdent_OETyp
    );
    if (this.data.new) {
      const URL = this.excRest.computeUrl('OeC');
      this.excRest.post(URL, { oeIDparent: this.data.oeIDparent, ...this.UiOEModel}).subscribe((ret: any) => {
        if (ret?.success && ret.data?.OE) {
          this.modal.showToast( uiName + ' wurde erfolgreich angelegt', 'md-toast', 'fal fa-check');
          this.OEDetails = ret.data.OE;
          this.toggleOEEditor();
          this.data.new = false;
        } else {
          this.modal.showToast(
            this.getRessource('Anlage fehlgeschlagen')
            , 'md-toast', 'fas fa-exclamation');
        }
      });
    } else {
      const URL = this.excRest.computeUrl('OeU', {oeID: this.OEDetails.oeID});
      this.excRest.put(URL, {...this.UiOEModel}).subscribe((ret: any) => {
        if (ret?.success && ret.data?.OEDetails) {
          this.modal.showToast(uiName + ' wurde erfolgreich bearbeitet', 'md-toast', 'fal fa-check');
          this.OEDetails = ret.data.OEDetails;
          this.toggleOEEditor();
        } else {
          this.modal.showToast(
            this.getRessource('Bearbeitung fehlgeschlagen')
            , 'md-toast', 'fas fa-exclamation');
        }
      });
    }
  }

  toggleOEEditor(): void {
    this.visibilityController.showOEEditor = !this.visibilityController.showOEEditor;
    this.UiOEModel = this.appService.helperObj.clone(this.OEDetails);
    this.disabledController.checkIfOESavable();
  }

  /*Modal Methods*/
  close(): void {
    this.modal.close();
  }

  /*Address Methods*/
  onSearch(input: string): void {
    this.placesService.autocomplete({input}).subscribe((response: any) => {
      const placesObject: any[] = [];
      if (response.length > 0) {
        response.forEach((obj: any) => {
          placesObject.push(obj);
        });
      }
      this.placesList = placesObject;
    });
  }

  onResultClick(index: number): void {
    const place = this.placesService.toPlace(this.placesList[index]);
    // @ts-ignore
    place.then( data => {
      if (data?.place) {
        const countryCode = this.extractCountryCode(data?.place);
        this.assignLocationData(data.exgPlace, countryCode);
        this.locActive = true;
      }
    });
  }

  extractCountryCode(addressObject: any): string {
    if (!addressObject || !Array.isArray(addressObject.addressComponents)) {
      return '';
    }

    const countryComponent = addressObject.addressComponents.find((component: any) =>
      component.types.includes('country')
    );

    return countryComponent?.shortText || undefined;
  }
  assignLocationData(loc: any, countryCode: string ): void {
    this.AddressesList.oeAddressClone.adrBez = loc.name;
    this.AddressesList.oeAddressClone.adrFormatted = loc.formatted;
    this.AddressesList.oeAddressClone.adrHTML = loc.html;
    this.AddressesList.oeAddressClone.adrStr = loc.street;
    this.AddressesList.oeAddressClone.adrHNum = loc.street_number;
    this.AddressesList.oeAddressClone.adrPlz = loc.zip;
    this.AddressesList.oeAddressClone.adrOrt = loc.city;
    this.AddressesList.oeAddressClone.adrLkz = countryCode;
    this.AddressesList.oeAddressClone.adrLand = loc.country;
    this.AddressesList.oeAddressClone.adrLat = loc.lat;
    this.AddressesList.oeAddressClone.adrLng = loc.lng;
  }

  changeManuel(): void {
    this.showManuel = !this.showManuel;
    if (!this.showManuel && this.changedManuel) {
      this.resetSearch();
    }
  }

  resetSearch(): void {
    this.locActive = false;
    this.placesList = [];
    this.AddressesList.oeAddressClone = JSON.parse(JSON.stringify(this.data));
    this.changedManuel = false;
  }

  resetGeoCode(): void {
    this.AddressesList.oeAddressClone.adrLat = undefined;
    this.AddressesList.oeAddressClone.adrLng = undefined;
    this.changedManuel = true;
  }

  addressAction(data?: any): void {
    if (this.visibilityController.showAddressEditor) {
      if (data?.del) {
        this.excRest
          .delete(
            this.excRest.computeUrl('OeAdresseCUD', {
              oeID: this.OEDetails.oeID
            }), {adrID: this.AddressesList.oeAddressClone.adrID}
          )
          .subscribe((ret: any) => {
            if (ret.success) {
              this.modal
                .showToast('Adresse gelöscht'
                  , 'md-toast bg-green'
                  , 'far fa-check');
            }

            this.loadSummaryData();
          });
      } else {
        this.excRest
          .post(
            this.excRest.computeUrl('OeAdresseCUD', {
              oeID: this.OEDetails.oeID
            }), this.AddressesList.oeAddressClone
          )
          .subscribe((ret: any) => {
            if (ret.success) {
              if (this.AddressesList.oeAddressClone.adrID) {
                this.modal
                  .showToast('Adresse aktualisiert'
                    , 'md-toast bg-green'
                    , 'far fa-check');
              } else {
                this.modal
                  .showToast('Adresse erstellt'
                    , 'md-toast bg-green'
                    , 'far fa-check');
              }

              this.showHintText = false;
              this.loadSummaryData();
            }
          });
      }
      this.visibilityController.changeAddressEditor();
    }

  }

  /*Contacts Methods*/

  contactAction(data?: any): void {
    if (this.visibilityController.showContactEditor) {
      if (data?.del) {
        this.excRest
          .delete(this.excRest.computeUrl('OeContactCUD', {
            oeID: this.OEDetails.oeID
          }), {kontID: this.ContactsList.oeContactClone.kontID})
          .subscribe((ret: any) => {
            if (ret.success) {
              this.modal
                .showToast('Kontakt gelöscht', 'md-toast bg-green', 'far fa-check');
              this.loadSummaryData();
            }
          });
      } else {
        this.excRest
          .post(this.excRest.computeUrl('OeContactCUD', {
            oeID: this.OEDetails.oeID
          }), this.ContactsList.oeContactClone)
          .subscribe((ret: any) => {
            if (ret && ret.success) {
              if (this.ContactsList.oeContactClone.kontID) {
                this.modal
                  .showToast('Kontakt aktualisiert', 'md-toast bg-green', 'far fa-check');
              } else {
                this.modal
                  .showToast('Kontakt erstellt', 'md-toast bg-green', 'far fa-check');
              }
            }

            this.showHintText = false;
            this.loadSummaryData();
          });
      }
      this.visibilityController.changeContactEditor();
    }
  }

  loadSummaryData(): void {
    this.isLoading = true;
    const URL = this.excRest.computeUrl('OESummary_Short', {oeID: this.OEDetails.oeID});
    this.excRest.get(URL).subscribe((ret: any) => {
      if (ret.success) {
        this.OEDetails = ret.data.OEDetails;
        this.AddressesList.data = ret.data.Addresses;
        this.ContactsList.data = ret.data.Contacts;
        this.UiOEModel = this.appService.helperObj.clone(this.OEDetails);
      }
      this.isLoading = false;
    });
  }

  action(): void {
    if (this.isOeNew && this.ContactsList.data.length === 0 && this.AddressesList.data.length === 0) {
      this.showHintText = true;
    } else {
      this.doAction();
    }
  }

  openCRM(): void {
    if (this.excSecurity.isFeatured('CRMNAV')) {
      this.appSvc.OE.Workspace.OpenTab(
        this.OEDetails.oeID
      );
      this.modal.close();
    }
  }

  doAction(): void {
    this.modal.action({OEDetails: this.OEDetails});
  }
}
